// src/components/Pagination.js
import React, {Fragment} from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = new Set();

    // Всегда добавляем первые 3
    for (let i = 1; i <= Math.min(3, totalPages); i++) {
      pages.add(i);
    }

    // Всегда добавляем последние 3
    for (let i = Math.max(totalPages - 2, 4); i <= totalPages; i++) {
      pages.add(i);
    }

    // Добавляем текущую и соседей (если не входят в первые/последние)
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
      pages.add(i);
    }

    // Преобразуем в массив и сортируем
    return Array.from(pages).sort((a, b) => a - b);
  };

  const pageNumbers = getPageNumbers();

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination justify-content-center flex-wrap">
        {/* Кнопка "В начало" */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(1)}
            aria-label="Go to first page"
          >
            «
          </button>
        </li>

        {/* Кнопка "Назад" */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
            aria-label="Previous page"
          >
            ‹
          </button>
        </li>

        {/* Номера страниц */}
        {pageNumbers.map((page, index) => {
          // Проверяем, нужно ли добавить многоточие
          const prevPage = pageNumbers[index - 1];
          const showEllipsis = prevPage && page - prevPage > 1;

          return (
            <Fragment key={page}>
              {showEllipsis && (
                <li className="page-item disabled">
                  <span className="page-link">…</span>
                </li>
              )}
              <li className={`page-item ${currentPage === page ? 'active' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => onPageChange(page)}
                >
                  {page}
                </button>
              </li>
            </Fragment>
          );
        })}

        {/* Кнопка "Вперёд" */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
            aria-label="Next page"
          >
            ›
          </button>
        </li>

        {/* Кнопка "В конец" */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(totalPages)}
            aria-label="Go to last page"
          >
            »
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;



